import axios from 'axios';
import React, { useState, useEffect } from 'react';
import '../../../../i18n'
import { useTranslation } from 'react-i18next';

export default function NewsOverlay({ market }) {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(true);
    const [post, setPost] = useState(null);


    useEffect(() => {
        let cancelled = false;

        async function fetchData() {
            try {
                if (!market) {
                    if (!cancelled) {
                        setPost(null);
                        setIsVisible(false);
                    }
                    return;
                }
                const res = await axios({
                    method: 'get',
                    baseURL: process.env.REACT_APP_CONTURA_HEADLESS_BASE_URL,
                    url: '/rest-api/mediaApi/articles',
                    params: {
                        market: market,
                        isFlagged: true,
                        limit: 1,
                        sort: true,
                    }
                });

                if (!Array.isArray(res.data) || res.data.length === 0) return;

                const fetchedPost = res.data[0];
                const showNews = await showFlaggedNews(fetchedPost);

                if (!cancelled && showNews && fetchedPost?.id) {
                    setIsVisible(true);
                    setPost(fetchedPost);
                    localStorage.setItem(
                        'viewed',
                        JSON.stringify({
                            time: Date.now(),
                            id: fetchedPost.id,
                        })
                    );
                }
            } catch (err) {
                const status = err?.response?.status;
                console.error('Failed to fetch flagged news', { status, err });
                if (!cancelled) {
                    setPost(null);
                    setIsVisible(false);
                }
            }
        }

        fetchData();

        return () => {
            cancelled = true;
        };

    }, [market]);

    const closeOverlay = () => {
        setIsVisible(!isVisible);
    };

    /**
     * Check if flagged news should be displayed for the user
     * @param {*} post 
     * @returns Boolean
     */
    const showFlaggedNews = async (post) => {
        if (!post) return false;
        const viewed = await JSON.parse(localStorage.getItem('viewed'));
        const currentTime = Date.now();
        const hours = 168; // 168 = 7 days
        const timeLimit = 60 * 60 * 1000 * hours;
        // If there is a viewd post, check if it should be displayed again.
        if (viewed) {
            const timeDifference = currentTime - viewed.time;
            if (post?.id === viewed.id && timeDifference < timeLimit) {
                return false;
            }
        }

        return true;
    };

    return (
        <>
        {(isVisible && post) &&
            <div className="news-overlay-background">
                <div className="news-overlay-container">

                    <div className="news-overlay-card">
                        <a href={'/news/' + post?.id} onClick={closeOverlay}>
                            <img
                                alt="Not found"
                                src={post?.image}
                                className="card-img"
                            />
                            <h3 className="card-title">{post?.title}</h3>
                            <p className="card-abstract">{post?.abstract}</p>
                            <br></br>
                            <h5>{t('news.news-overlay.read-more')}</h5>
                        </a>
                    </div>
                    <button className="btn close-btn" onClick={closeOverlay}>
                        {t('news.news-overlay.close')}
                    </button>
                </div>
            </div>
        }
        </>

    );
}
